var React = require('react');

function ChevronUp (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M1.54169 7.22919L5.99925 3.0025L10.4588 7.23094C10.6352 7.41031 10.8656 7.50044 11.0964 7.5C11.3272 7.5 11.5584 7.40987 11.7352 7.22919C11.906 7.05506 11.9944 6.82844 12 6.60006L12 6.555C11.9944 6.32662 11.906 6.1 11.7352 5.92587L6.63845 0.770374C6.46525 0.593624 6.23925 0.503499 6.01285 0.499999L5.98765 0.499999C5.76085 0.503499 5.53525 0.593624 5.36166 0.770374L0.264898 5.92587C-0.0882987 6.28594 -0.0882987 6.87044 0.264898 7.22918C0.441297 7.40987 0.672094 7.5 0.903293 7.5C1.13409 7.5 1.36529 7.40987 1.54169 7.22919Z","fill":"#6F7881"}));
}

ChevronUp.defaultProps = {"width":"12","height":"8","viewBox":"0 0 12 8","fill":"none"};

module.exports = ChevronUp;

ChevronUp.default = ChevronUp;
